import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drv-form-root" }
const _hoisted_2 = { class: "drv-text-body-md drv-text-weight-medium" }

import { computed, ref } from "vue";
import HelpLink from "../HelpLink.vue";
import {
  ETelematicsMessagesKeys,
  IPlatform,
  IUsernameToken,
  EAuthTypes,
  ECommonMessages,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import {
  maxLengthValidator,
  minLengthValidator,
  requiredValidator,
} from "draivn-ui-domain";
import { HELP_URL_BY_PLATFORM } from "../../../../constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseUsernameToken',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit =
  __emit;

const EMPTY_MODEL = { type: EAuthTypes.TOKEN, username: "", token: "" };

const model = computed<IUsernameToken>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: IUsernameToken) {
    emit("update:modelValue", value);
  },
});

const usernameModel = computed<string>({
  get() {
    return props.modelValue?.username ?? EMPTY_MODEL.username;
  },
  set(value: string) {
    model.value = { ...model.value, username: value };
  },
});

const tokenModel = computed<string>({
  get() {
    return props.modelValue?.token ?? EMPTY_MODEL.token;
  },
  set(value: string) {
    model.value = { ...model.value, token: value };
  },
});

const usernameControl = ref<typeof Input | null>(null);
const tokenControl = ref<typeof Input | null>(null);
const hasError = computed<boolean>(() => {
  return (
    !usernameModel.value ||
    usernameControl.value?.hasError ||
    !tokenModel.value ||
    tokenControl.value?.hasError
  );
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_input = _resolveComponent("d-input")!
  const _component_d_password_input = _resolveComponent("d-password-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).BASE_USERNAME_TOKEN_INSTRUCTION_1_TITLE)), 1),
      _createVNode(HelpLink, {
        link: _ctx.$t(_unref(HELP_URL_BY_PLATFORM)[_ctx.platform.const])
      }, null, 8, ["link"])
    ]),
    _createVNode(_component_d_input, {
      ref_key: "usernameControl",
      ref: usernameControl,
      class: "drv-my-2 drv-form-control-adaptive",
      modelValue: usernameModel.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((usernameModel).value = $event)),
      label: _ctx.$t(_unref(ETelematicsMessagesKeys).BASE_USERNAME_TOKEN_USERNAME_TITLE),
      disable: _ctx.disable,
      "lazy-rules": "",
      rules: [
        _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
        _unref(maxLengthValidator)(
          100,
          _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
        ),
        _unref(minLengthValidator)(
          2,
          _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
        ),
      ]
    }, null, 8, ["modelValue", "label", "disable", "rules"]),
    _createVNode(_component_d_password_input, {
      ref_key: "tokenControl",
      ref: tokenControl,
      class: "drv-form-control-adaptive drv-my-2",
      modelValue: tokenModel.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tokenModel).value = $event)),
      disable: _ctx.disable,
      label: _ctx.$t(_unref(ETelematicsMessagesKeys).BASE_USERNAME_TOKEN_TITLE),
      "lazy-rules": "",
      rules: [
        _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
        _unref(maxLengthValidator)(
          100,
          _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
        ),
        _unref(minLengthValidator)(
          2,
          _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
        ),
      ]
    }, null, 8, ["modelValue", "disable", "label", "rules"])
  ]))
}
}

})